module.exports = __webpack_public_path__ + "static/retirement-planning-hero-mobile.deb2b4ee.webp";